import { css } from "lit";

export const styles = css`
  :host {
    display: flex;
    flex: 1 1 0%;
  }

  .launcher-button {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    padding: 12px 8px;
    background: none;
    border: none;
    cursor: pointer;
    color: var(--sds-color-text-default-tertiary);
    transition: color 0.2s ease;
    font: var(--sds-typography-weight-medium) var(--sds-typography-scale-01) var(--sds-typography-family-title);
  }

  .launcher-button:hover {
    color: var(--sds-color-text-default-secondary);
  }
`;
